"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Checks for the `disableGlobalClassNames` property on the `theme` to determine if it should return `classNames`
 *
 * @param theme The theme to check the flag on
 * @param classNames The global class names that apply when the flag is false
 */
function getGlobalClassNames(classNames, theme) {
    if (theme.disableGlobalClassNames) {
        return {};
    }
    return classNames;
}
exports.getGlobalClassNames = getGlobalClassNames;
//# sourceMappingURL=getGlobalClassNames.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@uifabric/styling/lib/styles/getGlobalClassNames.js
// module id = 987
// module chunks = 0